<div class="white-box main-black mt-4 p-4 border-radius">
	<div>
		<h4>{{ title | translate }} <app-help-tooltip [field]="tooltips"></app-help-tooltip></h4>
	</div>

	<div class="d-flex flex-wrap justify-content-between py-4">
		<div class="d-flex justify-content-start col-12 align-items-center px-0">
			<!-- select year -->
			<div class="col-3 pl-0">
				<label class="mr-2">{{'g.select_year' | translate}}</label>
				<ng-select
					[searchable]="false"
					[items]="yearList"
					bindLabel="label"
					bindValue="id"
					placeholder="{{'g.select_year' | translate}}"
					name="year"
					[(ngModel)]="selectedYear"
					[clearable]="false"
					(change)="selectYear()"
				></ng-select>
			</div>

			<!-- select period type -->
			<div class="col-3" *ngIf="selectedYear != allYearsId">
				<label class="mr-2">{{'site.select_period_type' | translate}}</label>
				<ng-select
					[items]="periodTypes"
					bindLabel="label"
					bindValue="value"
					placeholder="{{'site.select_period_type' | translate}}"
					name="period_type"
					[(ngModel)]="selectedPeriodType"
					[clearable]="false"
					(change)="selectPeriodType()"
				></ng-select>
			</div>

			<!-- select quarter -->
			<div *ngIf="selectedPeriodType == periods.QUARTERLY && selectedYear != allYearsId" class="col-3">
				<label class="mr-2">{{'g.select_quarter' | translate}}</label>
				<ng-select
					[searchable]="false"
					[items]="quarterList"
					bindLabel="label"
					bindValue="value"
					placeholder="{{'g.select_quarter' | translate}}"
					name="quarter"
					[(ngModel)]="selectedQuarter"
					[clearable]="false"
					(ngModelChange)="prepareData()"
				></ng-select>
			</div>

			<!-- select month -->
			<div *ngIf="selectedPeriodType == periods.MONTHLY && selectedYear != allYearsId" class="col-3">
				<label class="mr-2">{{'g.select_month' | translate}}</label>
				<ng-select
					[searchable]="false"
					[items]="monthList"
					bindLabel="label"
					bindValue="value"
					placeholder="{{'g.select_month' | translate}}"
					name="year"
					[(ngModel)]="selectedMonth"
					[clearable]="false"
					(ngModelChange)="prepareData()"
				></ng-select>
			</div>
			
			<!-- select Device Type -->
			<div class="col-3" *ngIf="!device">
				<label class="mr-2">{{'iotemeter_site_energy_report.select_meter_type' | translate}}</label>
				<ng-select
					[searchable]="false"
					[items]="devicesList"
					bindLabel="label"
					bindValue="value"
					placeholder="{{'iotemeter_site_energy_report.select_meter_type' | translate}}"
					name="device_type"
					[(ngModel)]="selectedDeviceType"
					[clearable]="false"
					(ngModelChange)="getIotemeterEnergyConsumption()"
				></ng-select>
			</div>
		</div>
	</div>

	<div class="scores-wrapper" *ngIf="data.hasData">
		<div class="score-card">
			<div>
				<strong><p>{{ 'iotemeter_site_energy_report.total_energy_consumed' | translate }}</p></strong>
			</div>

			<h4><b>{{data.consumed_energy}}</b></h4>
			<span>{{'g.kWh' | translate}}</span>
		</div>

		<div class="score-card">
			<div>
				<strong><p>{{ 'iotemeter_site_energy_report.average_daily_energy' | translate }}</p></strong>
			</div>

			<h4><b>{{data.average_consumed_energy}}</b></h4>
			<span>{{'g.kWh' | translate}}/{{'time.day' | translate}}</span>
		</div>

		<div class="score-card">
			<div>
				<strong><p>{{ 'iotemeter_site_energy_report.peak_energy_demand' | translate }}</p></strong>
			</div>

			<h4><b>{{data.peak_energy_demand}}</b></h4>
			<span>{{'g.kw' | translate}}</span>
		</div>
	</div>

	<div class="scores-wrapper" *ngIf="data.hasData; else noData">
		<div class="score-card">
			<b>{{'iotemeter_site_energy_report.cost_breakdown' | translate}}</b>

			<div class="d-flex align-items-center justify-content-center p-4">
				<div class="position-relative mr-5">
					<svg width="220" height="220" viewBox="0 0 200 200" style="transform: none;">
						<defs>
							<filter id="innerShadow" x="-20%" y="-20%" width="140%" height="140%">
								<feDropShadow dx="0" dy="2" stdDeviation="6" flood-color="#000000" flood-opacity="0.15" />
							</filter>
						</defs>
						<!-- Orange Ring -->
						<circle cx="100" cy="100" r="65" fill="none" stroke="#FFA100" stroke-width="34" [attr.stroke-dasharray]="getDemandDashArray()" [attr.stroke-dashoffset]="getDemandDashOffset()" transform="rotate(-90 100 100)" />
						<!-- Blue Ring -->
						<circle cx="100" cy="100" r="65" fill="none" stroke="#28A2FF" stroke-width="34"
							[attr.stroke-dasharray]="getEnergyDashArray()" transform="rotate(-90 100 100)" />
						<!-- Inner White Circle -->
						<circle cx="100" cy="100" r="50" fill="#FFFFFF" filter="url(#innerShadow)" />
			
						<!-- Center Text -->
						<text x="100" y="90" text-anchor="middle" font-size="13" font-weight="600" fill="#6C7584" letter-spacing="1.5">{{'g.total' | translate}}</text>
						<text x="100" y="125" text-anchor="middle" font-size="18" font-weight="800" fill="#1C212D">{{ getCostBreakdownPercentage() }}</text>
					</svg>
					<div class="h4"><b>${{ data.total_cost }}</b></div>
				</div>

				<div class="d-flex flex-column justify-content-center">
					<div class="d-flex align-items-start mb-4">
						<div class="legend-icon icon-blue mt-1 mr-3"></div>
						<div class="d-flex flex-column text-left">
							<div class="legend-title">{{'iotemeter_site_energy_report.energy_cost' | translate}}</div>
							<div class="legend-value">${{ data.energy_cost }} ({{'iotemeter_site_energy_report.estimated' | translate}})</div>
							<div class="legend-percentage">{{ data.energy_cost_percent }}%</div>
						</div>
					</div>
					<div class="d-flex align-items-start">
						<div class="legend-icon icon-orange mt-1 mr-3"></div>
						<div class="d-flex flex-column text-left">
							<div class="legend-title">{{'iotemeter_site_energy_report.demand_changes' | translate}}</div>
							<div class="legend-value">${{ data.demand_charges }} ({{'iotemeter_site_energy_report.estimated' | translate}})</div>
							<div class="legend-percentage">{{ data.demand_charges_percent }}%</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>

	<ng-template #noData class="mt-4">
		<div class="alert alert-info">{{'g.no_data_to_show' | translate}}</div>
	</ng-template>
</div>